import { Human, Manager, RoundStage } from 'hearts-engine';

export class MultiplayerGameManager extends Manager {
	isMgm = true;

	constructor(room) {
		super();
		this.gameState = JSON.parse(room.state.gameState) || {};
		this.room = room;
		this.#setupPlayers();
		this.room.state.listen('gameState', (newValue) => {
			this.gameState = JSON.parse(newValue);
			this.emitNewState();
		});
		this.room.state.players.onChange(() => {
			this.#setupPlayers();
		});
	}

	createNewGame() {
		//TODO make this better by not using this hack :(
		if (this.gameState?.roundStage === RoundStage.GameOver) { //handle the case where a game is trying to be created when we don't have a game created yet
			this.room.send('newGame');
		} else {
			super.createNewGame();
		}
	}

	action(command) {

		if (this.can(command)) {
			this.room.send('action', command);
			return true;
		}

		return false;
	}

	#setupPlayers() {
		const users = [];

		for (const player of this.gameState.players) {
			const p = new Human(player);

			users[player.position] = p;
		}

		this.users = users;
	}
}
